import React, { Component } from 'react'
import Fbacklist from './FbackList'
import FbackSearch from './FbackSearch'
import Styles from './style.module.less'
import store from './store'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { status }
      }
    } = this.props
    if (status) {
      store.setStatus(status)
    }
  }
  render() {
    return (
      <div className={Styles.myorder}>
        <div className={Styles.myorderTit}>
          <h3>订单反馈</h3>
        </div>
        <div className={Styles.myorderBox}>
          <FbackSearch />
          <Fbacklist />
        </div>
      </div>
    )
  }
}
